import { render } from "./PieChartControl.vue?vue&type=template&id=bb0376dc&ts=true"
import script from "./PieChartControl.vue?vue&type=script&lang=ts"
export * from "./PieChartControl.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__